import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { CHECK_DATE_REPORT, PAYMENT_METHOD_LIMITS } from "app/appConfig";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  getDepartmentsUser,
  isAdmin,
  transformDate,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect } from "react";
import * as Yup from "yup";
import VoucherPopupDetail from "../PatientGeneral/PatientGeneralTabs/FeeTab/Popup/VoucherPopupDetail";
import ReportPaymentDepartmentPieChart from "./Component/ReportPaymentDepartmentPieChart";
import ReportPaymentOrganizationPieChart from "./Component/ReportPaymentOrganizationPieChart";
import ReportPaymentMethodPieChart from "./Component/ReportPaymentMethodPieChart";
import SearchChart from "./Component/SearchChart";
import ReportPaymentList from "./ReportPaymentList";
import ReportPaymentSearch from "./ReportPaymentSearch";

export default memo(observer(function ReportPaymentIndex() {
  const {
    pagingReportVoucher,
    pagingReportPayment,
    handleChangeFormSearchVoucher,
    searchReportVoucher,
    dataChart,
    dataPayment,
    listData,
  } = useStore().patientManagementStore.reportPaymentStore;
  const {
    dataVoucherPopupFee,
    editableVoucher,
    listStk,
    handleUpdateVoucher,
    handleCloseServiceFeePopup,
    openVoucherPopupDetail,
  } = useStore().feeStore.serviceFeeTabStore;
  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().transform(transformDate).nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .nullable()
      .test("validate-date-range", function (value) {
        const { fromDate } = this.parent;

        // Chưa chọn cả hai
        if (!fromDate && !value) {
          return this.createError({
            message: "Bạn chưa chọn ngày thanh toán từ - đến!",
            path: "toDate", // chỉ hiển thị 1 lỗi tại toDate
          });
        }

        //  Chưa chọn từ ngày
        if (!fromDate) {
          return this.createError({
            message: "Bạn chưa chọn ngày thanh toán từ!",
            path: "toDate",
          });
        }

        // Chưa chọn đến ngày
        if (!value) {
          return this.createError({
            message: "Bạn chưa chọn ngày thanh toán đến!",
            path: "toDate",
          });
        }

        // Đến ngày trước từ ngày
        if (moment(value).isBefore(moment(fromDate), "date")) {
          return this.createError({
            message: "Đến ngày không được trước từ ngày",
            path: "toDate",
          });
        }

        // Quá giới hạn CHECK_DATE_REPORT
        const diff = dayjs(value).diff(dayjs(fromDate), "day");
        if (diff > CHECK_DATE_REPORT) {
          return this.createError({
            message: `Khoảng thời gian không được vượt quá ${CHECK_DATE_REPORT} ngày`,
            path: "toDate",
          });
        }

        return true;
      }),

    departmentIds: Yup.array()
      .min(1, "Bạn phải chọn ít nhất 1 cơ sở")
      .required("Bạn phải chọn ít nhất 1 cơ sở"),
  });
  const department = useDefaultDepartment();
  let listDepartmentByUser = getDepartmentsUser();
  const isAdminRole = isAdmin();
  // useEffect(() => {
  //   if (!searchReportVoucher.departmentIds || searchReportVoucher.departmentIds.length === 0) {
  //     handleChangeFormSearchVoucher({
  //       departmentIds: listDepartmentByUser || [department],
  //     });
  //   }
  //   pagingReportPayment();
  // }, [department]);

  useEffect(() => {
    const defaultSearch = {
      departmentIds: searchReportVoucher.departmentIds?.length
        ? searchReportVoucher.departmentIds
        : isAdminRole
          ? department
            ? [department]
            : []
          : listDepartmentByUser || [],
      limitPaymentMethodCodes: PAYMENT_METHOD_LIMITS,
    };
    handleChangeFormSearchVoucher(defaultSearch);
    pagingReportPayment();
  }, [department]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{ ...searchReportVoucher }}
        onSubmit={(values) => {
          const trimmedValues = trimStringsInObject(values);
          handleChangeFormSearchVoucher({ ...trimmedValues, pageIndex: 1 });
        }}
        validationSchema={validationSchema}
      >
        <Form autoComplete="off">
          <section className="cards-container">
            <SearchChart />
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <ReportPaymentDepartmentPieChart
                  data={dataChart}
                  isMobile={isMobile}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <ReportPaymentOrganizationPieChart
                  data={dataChart}
                  isMobile={isMobile}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <ReportPaymentMethodPieChart
                  data={listData}
                  isMobile={isMobile}
                />
              </Grid>
            </Grid>

            <ReportPaymentSearch />
            <ReportPaymentList dataPayment={dataPayment} />
            {openVoucherPopupDetail && (
              <VoucherPopupDetail
                open={openVoucherPopupDetail}
                handleClose={handleCloseServiceFeePopup}
                detailData={dataVoucherPopupFee}
                editable={editableVoucher}
                handleUpdateVoucher={handleUpdateVoucher}
                listStk={listStk}
              />
            )}
          </section>
        </Form>
      </Formik>
    </>
  );
})
);

export const trimStringsInObject = (obj) => {
  const result = { ...obj };
  for (const key in result) {
    if (typeof result[key] === "string") {
      result[key] = result[key].trim();
    }
  }
  return result;
};
